<template>
  <div class="not-found">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h1>Ой...</h1>
          <h3>Нет такой страницы</h3>
          <p>Наверное, ссылка неправильная.</p>
        </div>
        <div class="col-md-6">
          <router-link :to="{ name: 'firstStep' }"><img :src="image" alt="Не найдено"></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import image from '../assets/img/not-found.png'

export default {
  name: 'nofFound',
  data: function () {
    return {
      image: image
    }
  }
}
</script>
